import { Auth0Provider, AppState } from '@auth0/auth0-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  REACT_APP_AUTH0_AUDIENCE,
  REACT_APP_AUTH0_CLIENT_ID,
  REACT_APP_AUTH0_DOMAIN,
} from '../../configs/envs';

export const Auth0ProviderWithNavigate = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState?: AppState) => {
    navigate(appState?.returnTo || '/', { replace: true });
  };

  return (
    <Auth0Provider
      domain={REACT_APP_AUTH0_DOMAIN}
      clientId={REACT_APP_AUTH0_CLIENT_ID}
      onRedirectCallback={onRedirectCallback}
      // Persist the token cache so a page reload doesn't discard the session.
      // The default ('memory') wipes tokens on every refresh, forcing a fresh
      // token acquisition each time. We already store the access token in
      // localStorage (see AxiosInterceptor), so this doesn't change the
      // security posture.
      cacheLocation="localstorage"
      // Renew tokens via the refresh-token grant instead of a hidden iframe.
      // The iframe path relies on the Auth0 session cookie — a third-party
      // cookie that modern browsers block on localhost (and increasingly
      // everywhere), so silent renewal fails and the SDK falls back to an
      // interactive redirect, re-showing the Auth0 login/consent screen
      // repeatedly. Requires "Allow Offline Access" on the Auth0 API.
      useRefreshTokens
      // Safety net: if no refresh token is available (e.g. offline access not
      // yet enabled on the API), fall back to the iframe flow rather than
      // hard-failing token renewal — i.e. degrade to the previous behaviour.
      useRefreshTokensFallback
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: REACT_APP_AUTH0_AUDIENCE,
      }}
    >
      {children}
    </Auth0Provider>
  );
};
